module.exports = __webpack_public_path__ + "static/img/stationunitbox.c178c56d.jpg";